import { createConfig, http } from "wagmi";
import { base, baseSepolia, mainnet, sepolia } from "wagmi/chains";
import { coinbaseWallet, injected } from "wagmi/connectors";

const APP_NAME = "Kaia Workshop Dapp";

// Prefer explicit RPCs (Pages env vars), fall back to default chain RPCs.
const mainnetRpc = import.meta.env.VITE_MAINNET_RPC_URL as string | undefined;
const baseRpc = import.meta.env.VITE_BASE_RPC_URL as string | undefined;
const sepoliaRpc = import.meta.env.VITE_SEPOLIA_RPC_URL as string | undefined;
const baseSepoliaRpc = import.meta.env.VITE_BASE_SEPOLIA_RPC_URL as string | undefined;

export const config = createConfig({
  chains: [mainnet, base, sepolia, baseSepolia],
  connectors: [
    coinbaseWallet({
      appName: APP_NAME
    }),
    // Nice fallback for local dev.
    injected({ shimDisconnect: true })
  ],
  transports: {
    [mainnet.id]: mainnetRpc ? http(mainnetRpc) : http(),
    [base.id]: baseRpc ? http(baseRpc) : http(),
    [sepolia.id]: sepoliaRpc ? http(sepoliaRpc) : http(),
    [baseSepolia.id]: baseSepoliaRpc ? http(baseSepoliaRpc) : http()
  }
});


